if (!customElements.get('benefits-subscription')) {
  customElements.define('benefits-subscription', class extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
    }

    connectedCallback() {
      this.slides = this.querySelectorAll('.benefits-subscription__slide');
      this.navItems = this.querySelectorAll('.benefits-subscription__nav-item');
      this.mobileTitles = this.querySelectorAll('.benefits-subscription__mobile-nav-title');

      this.navItems.forEach((item, index) => {
        item.addEventListener('click', () => {
          this.setActiveSlide(index);
        });
      });
      
      this.initialized = true;
    }

    setActiveSlide(index) {
      if (index === this.currentIndex && this.initialized) return;
      this.currentIndex = index;

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      this.navItems.forEach((item, i) => {
        const isActive = i === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive.toString());
      });
      
      this.mobileTitles.forEach((title, i) => {
        title.classList.toggle('is-active', i === index);
      });
    }
  });
}
